import React, { useId, useRef, useState } from "react";
import useMenuFooterReveal from "./useMenuFooterReveal";
import "../../styles/MozzoFiscalBadge.css";

// Keep ARCA's supplied entry URL: it redirects to its HTTPS service.
export const MOZZO_FISCAL_URL = "http://qr.afip.gob.ar/?qr=lRF-9hL2DA_U7Kc-GSuA9A,,";
export const MOZZO_FISCAL_IMAGE_URL = "https://www.afip.gob.ar/images/f960/DATAWEB.jpg";

const labels = {
  es: {
    title: "Datos fiscales de MozzoApp",
    hint: "Abre ARCA en otra ventana",
    show: "Ver datos fiscales",
    hide: "Ocultar datos fiscales",
  },
  en: {
    title: "MozzoApp tax information",
    hint: "Opens ARCA in a new window",
    show: "View tax information",
    hide: "Hide tax information",
  },
  pt: {
    title: "Dados fiscais da MozzoApp",
    hint: "Abre a ARCA em outra janela",
    show: "Ver dados fiscais",
    hide: "Ocultar dados fiscais",
  },
};

export default function MozzoFiscalBadge({ language = "es" }) {
  const [imageFailed, setImageFailed] = useState(false);
  const copy = labels[language] || labels.es;

  return (
    <div className="mozzo-fiscal-badge">
      <a
        className="mozzo-fiscal-badge__link"
        href={MOZZO_FISCAL_URL}
        target="_F960AFIPInfo"
        rel="noopener noreferrer"
        aria-label={`${copy.title}. ${copy.hint}`}
      >
        {!imageFailed && (
          <img
            className="mozzo-fiscal-badge__image"
            src={MOZZO_FISCAL_IMAGE_URL}
            alt="Data Fiscal"
            width={239}
            height={327}
            loading="lazy"
            decoding="async"
            referrerPolicy="no-referrer"
            onError={() => setImageFailed(true)}
          />
        )}
        <span className="mozzo-fiscal-badge__copy">
          <span>{copy.title}</span>
          <span className="mozzo-fiscal-badge__hint">{copy.hint}</span>
        </span>
      </a>
    </div>
  );
}

export function MozzoFiscalMenuFooter({ language }) {
  const [expanded, setExpanded] = useState(false);
  const footerRef = useRef(null);
  const contentId = useId();
  const copy = labels[language] || labels.es;
  useMenuFooterReveal(footerRef, expanded, setExpanded);

  return (
    <footer ref={footerRef} className="mozzo-fiscal-menu-footer">
      <button
        type="button"
        className="mozzo-fiscal-menu-footer__toggle"
        aria-expanded={expanded}
        aria-controls={contentId}
        onClick={() => setExpanded(!expanded)}
      >
        {expanded ? copy.hide : copy.show}
      </button>
      <div id={contentId} hidden={!expanded}>
        <MozzoFiscalBadge language={language} />
      </div>
    </footer>
  );
}
